export const themeColors = {
  'Brand Strong': {
    background: 'bg-brand-strongest',
    headerText: 'text-brand-base',
    bodyText: '#FFFFFF'
  },
  'Brand Weak': {
    background: 'bg-brand-weakest',
    headerText: 'text-[#067464]',
    bodyText: '#111212'
  },
  'Grape Strong': {
    background: 'bg-accent1-strongest',
    headerText: 'text-accent1-base',
    bodyText: '#FFFFFF'
  },
  'Grape Weak': {
    background: 'bg-[#EBECFF]',
    headerText: 'text-[#7375DC]',
    bodyText: '#111212'
  },
  'Lagoon Strong': {
    background: 'bg-[#00364D]',
    headerText: 'text-accent2-base',
    bodyText: '#FFFFFF'
  },
  'Lagoon Weak': {
    background: 'bg-[#DFF5FF]',
    headerText: 'text-lagoon-800',
    bodyText: '#111212'
  },
  'Lime Strong': {
    background: 'bg-accent3-strongest',
    headerText: 'text-accent3-base',
    bodyText: '#FFFFFF'
  },
  'Lime Weak': {
    background: 'bg-[#F0F5C1]',
    headerText: 'text-accent3-strong',
    bodyText: '#111212'
  },
  'Tangerine Strong': {
    background: 'bg-accent4-strongest',
    headerText: 'text-accent4-base',
    bodyText: '#FFFFFF'
  },
  'Tangerine Weak': {
    background: 'bg-[#FFF1DD]',
    headerText: 'text-accent4-strong',
    bodyText: '#111212'
  },
  'Piggybank Strong': {
    background: 'bg-[#581226]',
    headerText: 'text-accent5-base',
    bodyText: '#FFFFFF'
  },
  'Piggybank Weak': {
    background: 'bg-[#FFE8F1]',
    headerText: 'text-accent5-strongest',
    bodyText: '#111212'
  }
};
